export const INLINE_SELECT_VENDOR_FIELDS = {
  id: null,
  title: null,
  businessEntity: {
    id: null,
    title: null,
  },
} as const;
